import React, { useEffect, useState } from 'react';
import { BaseTable, Button, FormField, Modal, Select, TextInput, Option, Label, Toggle, SingleDatePicker, SinglePickerValueType, TextTypes } from '@sede-enterprise/shell-ds-react-framework';
import { Add, Search } from '@sede-enterprise/shell-ds-react-framework/build/esm/components/Icon/components';
import { ColumnDef } from '@tanstack/react-table';
import dayjs from 'dayjs';
import { Col, Row } from '../flexbox/Flex';
import { AnchorSpan, ContainerDiv } from '../styledComponent/StyledComponent';
import { postData } from '../../services/ApiService';
import { ApiUrls } from '../../helpers/ApiUrls';
import { DefaultOptionType } from 'rc-select/lib/Select';
import ResponseErrorModal from '../responseErrorModal/ResponseErrorModal';
import Loader from '../loader/Loader';
import { useToast } from 'rc-toastr';
import { APIErrorResponseInterface } from '../../helpers/InterfacesConstants';
import StatusCell from '../common/StatusCell';

interface AirportSiteInterface  {
    id? : string;
    country : string;
    startDate : SinglePickerValueType | null;
    endDate : SinglePickerValueType | null;
    isActive : boolean;
    isLocal : boolean;
    airport: string;
}


const AirportSite = (props: any) => {
    const [openModal, setOpenModal] = useState(false);
    const [modelTitle, setModelTitle] = useState('');

    const [searchText, setSearchText] = useState('');
    const [ miAirportSites, setMiAirportSites] = useState<AirportSiteInterface[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isOnLoad, setIsOnLoad] = useState(true);
    const [countriesList, setCountriesList ] = useState<{countryId: string, countryName: string, airports:{airportId: number, airportName:string}[]}[]>([]);

    const [airportList, setAirportList ] = useState<{airportId: number, airportName: string}[]>([]);
    const [airportSiteDetails, setAirportSiteDetails] = useState<AirportSiteInterface>({
        id: '',
        country :  '',
        airport:  '',
        startDate : null,
        endDate : null,
        isActive : false,
        isLocal : false
    });

    const { toast } = useToast();
    const [apiErrorResponse, setApiErrorResponse] = useState<APIErrorResponseInterface | null>();

    const columns: ColumnDef<AirportSiteInterface>[] = [{
        header: 'Country',
        accessorKey: 'country',
        size: 60
    }, {
        header: 'Airport Site',
        accessorKey: 'airport',
        size: 60
    }, {
        header: 'Start Date',
        accessorKey: 'startDate',
        cell: ({row}) =>{
            return(
                dayjs(row.original.startDate).format('DD MMM YYYY')
            )
        },
        size: 60
    }, {
        header: 'End Date',
        accessorKey: 'endDate',
        cell: ({row}) =>{
            return(
                dayjs(row.original.endDate).format('DD MMM YYYY')
            )
        },
        size: 60
    }, {
        header: 'Status',
        accessorKey: 'isActive',
        cell: ({row}) =>{
            const status = row.original.isActive;
            return(
                <StatusCell status={status}/>
            )
        },
        size: 60
    }, {
        header: 'Local Customer',
        accessorKey: 'isLocal',
        cell: ({row}) =>{
            const isLocal = row.original.isLocal;
            return(
                isLocal ? 'True' : 'False'
            )
        },
        size: 60
    }, {
        header: 'Action',
        accessorKey: 'id',
        size: 60,
        cell: ({row}) =>{
            return(
                <AnchorSpan onClick={()=>{handleEditClick(row.original)}} key={row.id} style={{float: 'right', justifyContent: 'end', minWidth: '35px'}}>Edit</AnchorSpan>
            )
        },
    }];

    const handleEditClick = (row: AirportSiteInterface) => {
        setModelTitle('Edit MI Airport Site');
        setAirportSiteDetails({...row, startDate: dayjs(row.startDate), endDate: dayjs(row.endDate)});
        setOpenModal(true);
    }

    const handleAddClick = () => {

        setCountriesList(props.getcountrylst());
        setModelTitle('Add MI Airport Site');
        setAirportSiteDetails({
            country :  '',
            startDate :  null,
            endDate :   null,
            isActive :  true,
            isLocal: false,
            airport:  ''
        });
        setOpenModal(true);
    }

    
    const save = () => {
        const obj = {
            ...airportSiteDetails,
            startDate: dayjs(airportSiteDetails.startDate).format('YYYY-MM-DD'),
            endDate: dayjs(airportSiteDetails.endDate).format('YYYY-MM-DD')
        }
        console.log("Save clciked...!", obj);
        postData(ApiUrls.addorupdateairport, obj).then((response) => {
            if(response.status == 200){
                getMiAirportSites("");
                toast.success("Added Airport Site to MI List");
                setOpenModal(false);
            }
        }).catch((error) => {
            setApiErrorResponse({
                message : error.response.data.message,
                traceId : error.response.data.traceId
            });
        });
    }

    const getMiAirportSites = (search: string) => {
        setIsLoading(true);
        postData(ApiUrls.miAirportSites, {"searchTerm": search}).then((response) => {
            setIsLoading(false);
            setMiAirportSites(response.data);
        }).catch((error) => {
            setIsLoading(false);
            setApiErrorResponse({
                message : error.response.data.message,
                traceId : error.response.data.traceId
            });
        })
    }

    useEffect(() => {
        if(isOnLoad){
            setIsOnLoad(false);
            getMiAirportSites(searchText);
        }
    },[searchText]);


    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            getMiAirportSites(searchText);
        }
    };

    const onCountriesSelect=(selectedCountry: string, option: DefaultOptionType | DefaultOptionType[] )=>{
        if (Array.isArray(option)) {
            option.forEach((opt) => {
                if(opt['data-airports']){
                    setAirportList(opt['data-airports']);
                }
            });
        } else {
            if(option && option['data-airports']){
                setAirportList(option['data-airports']);
            }else{
                setAirportList([]);
            }
        }
        setAirportSiteDetails({...airportSiteDetails, country: selectedCountry, airport: ''});
    }


    return (
        <>
            <ContainerDiv>
                <Row>
					<Col size='65'>
						<Button onClick={()=>{handleAddClick()}}><Add/>Add MI Airport Site</Button>
					</Col>
                    <Col size='35'>
                        <Row>
                            <Label bold style={{paddingRight:'4px'}} type={TextTypes.Label} htmlFor='search'>Search</Label>
                            <TextInput size="medium" onChange={(event)=>{setSearchText(event.target.value)}} suffix={{node: <Search />}} placeholder="Search by Airport Site Code" id="search" onKeyDown={handleKeyDown}/>
                        </Row>
					</Col>
                </Row>
            </ContainerDiv>
            
            <Row>
                <Col size="100">
                    { !isLoading && <BaseTable data={miAirportSites} columns={columns} noFooter/>}
                    { isLoading && <Loader/> }  
                </Col>
            </Row>

            <Modal  open={openModal} onClose={() => {
                    setOpenModal(false);
                }} 

                actions={[{
                    label: 'Save',
                    action: () => {
                        save()
                    }
                }]}
                title={modelTitle}
                
                >
                <>
                    <FormField id="country" label="Country">
                        <Select value={airportSiteDetails?.country} onChange={(value, option)=>onCountriesSelect(value, option)} >
                        {countriesList.map((country)=>(
                            <Option value={country.countryName} key={country.countryId} data-airports={country.airports}>{country.countryName}</Option>
                        ))}
                        </Select>
                    </FormField>

                    <FormField id="airportSite" label="Airport Site">
                        <Select value={airportSiteDetails?.airport} onChange={(value)=>{setAirportSiteDetails({...airportSiteDetails, airport: value})}}>
                            {airportList.map((airport)=>(
                                <Option key={airport.airportId} value={airport.airportName}>{airport.airportName}</Option>
                            ))}
                        </Select>
                    </FormField>

                    <FormField id="startDate" label="Start Date">
                        <SingleDatePicker value={airportSiteDetails?.startDate} onChange={(e) =>{setAirportSiteDetails({...airportSiteDetails, startDate: e})}} size='small' showToday={false}/>
                    </FormField>

                    <FormField id="endDate" label="End Date">
                        <SingleDatePicker value={airportSiteDetails?.endDate} onChange={(e) =>{setAirportSiteDetails({...airportSiteDetails, endDate: e})}} size='small' showToday={false}/>
                    </FormField>

                    <div style={{marginBottom:'10px'}}>
                    <Row>
                        <Col size="90"><Label bold className='statusLabel'>Status</Label></Col>
                        <Col size="10"><Toggle checked={airportSiteDetails.isActive} onChange={ (value) => {setAirportSiteDetails({...airportSiteDetails, isActive: value})}} /></Col>
                    </Row>
                    </div>
                    <Row>
                        <Col size="90"><Label bold className='statusLabel'>Local Customer</Label></Col>
                        <Col size="10"><Toggle checked={airportSiteDetails.isLocal} onChange={ (value) => {setAirportSiteDetails({...airportSiteDetails, isLocal: value})}} /></Col>
                    </Row>
                </>
            </Modal>
            <ResponseErrorModal errorDetails={apiErrorResponse} isOpen={apiErrorResponse ? true : false} onModalClose={()=>{setApiErrorResponse(null)}}></ResponseErrorModal>
        </>
    )
}
export default AirportSite;